module.exports = __webpack_public_path__ + "static/media/line-top.04a4c3af.svg";